<input
  type="tel"
  #phone
  [disabled]="disabled"
  [maxLength]="12"
  (input)="onInput($event)"
  [attr.aria-describedby]="userAriaDescribedBy"
  placeholder="Mobile Number"
  class="tw-w-full tw-py-3 tw-px-3 tw-border-[0.5px] tw-border-SmallHeading tw-border-opacity-50 tw-rounded-md disabled:tw-text-SmallHeading tw-h-full !tw-pl-[5.25rem]"
/>
